import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { updatebooking } from '../../../_actions/user.action';
import CustomTable from '../../../customControl/CustomTable';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import FlightBookingDetailPopup from './FlightBookingDetailPopup';
import HotelBookingDetailPopup from './HotelBookingDetailPopup';

const BookingTable = (props) => {
    const { activeTab, listData, setSearchDropdownList, userRights } = props;
    const dispatch = useDispatch();
    const [bookingId, setBookingId] = useState(0);
    const [modalShow, setModalShow] = useState(false);
    const message = activeTab === 'Upcoming' ? "Are you sure you want to confirm the booking?" : "Are you sure you want to cancel the booking?"

    const columns = [
        {
            name: 'Sr. No',
            value: 'SrNo',
            sortable: true,
            reorder: true,
            maxWidth: '50px',
            minWidth: '50px',
            selector: (data) => data?.SrNo,
            format: (data) => <div title={data?.SrNo} >{data?.SrNo} </div>,
        },
        {
            name: 'Booking ID',
            value: 'BookingNo',
            sortable: true,
            reorder: true,
            selector: (data) => data?.BookingNo,
            format: (data) => <div title={data?.BookingNo} >{data?.BookingNo} </div>,
        },
        {
            name: 'Product',
            value: 'Product',
            sortable: true,
            reorder: true,
            selector: (data) => data?.Product,
            format: (data) => <div title={data?.Product} >{data?.Product} </div>,
        },
        // {
        //     name: 'Name',
        //     value: 'Name',
        //     sortable: true,
        //     reorder: true,
        //     minWidth: '150px',
        //     selector: (data) => data?.Name,
        //     format: (data) => <div title={data?.Name} >{data?.Name} </div>,
        // },
        {
            name: 'First Name',
            value: 'FirstName',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            selector: (data) => data?.FirstName,
            format: (data) => <div title={data?.FirstName} >{data?.FirstName} </div>,
        },
        {
            name: 'Last Name',
            value: 'LastName',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            selector: (data) => data?.LastName,
            format: (data) => <div title={data?.LastName} >{data?.LastName} </div>,
        },
        {
            name: 'Contact Number',
            value: 'MobileNo',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            selector: (data) => data?.MobileNo,
            format: (data) => <div title={data?.MobileNo} >{data?.MobileNo} </div>,
        },
        {
            name: 'Email ID',
            value: 'EmailId',
            sortable: true,
            reorder: true,
            minWidth: '250px',
            selector: (data) => data?.EmailId,
            format: (data) => <div title={data?.EmailId} >{data?.EmailId} </div>,
        },
        {
            name: 'Payment Status',
            value: 'PaymentStatus',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            selector: (data) => data?.PaymentStatus,
            format: (data) => <div title={data?.PaymentStatus} >{data?.PaymentStatus} </div>,
        },
        {
            name: 'No. Of pax/traveler/Guest',
            value: 'NoOfTraveller',
            sortable: true,
            reorder: true,
            minWidth: '50px',
            maxWidth: '50px',
            selector: (data) => data?.NoOfTraveller,
            format: (data) => <div title={data?.NoOfTraveller} >{data?.NoOfTraveller} </div>,
        },
        {
            name: 'Booking Date',
            value: 'CreatedDateformat',
            sortable: true,
            reorder: true,
            minWidth: '150px',
            selector: (data) => new Date(data?.CreatedDate),
            format: (data) => <div title={data?.CreatedDateformat} >{data?.CreatedDateformat} </div>,
        },
        {
            name:activeTab !== 'Cancelled'? 'Journey Start Date':'Journey Start/Check-in Date',
            value: 'StartDateformat',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            selector: (data) => new Date(data?.StartDate),
            format: (data) => <div title={data?.StartDateformat} >{data?.StartDateformat} </div>,
        },
        {
            name:activeTab !== 'Cancelled'? 'Journey End Date':'Journey End/Check-out Date',
            value: 'EndDateformat',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            selector: (data) => new Date(data?.EndDate),
            format: (data) => <div title={data?.EndDateformat} >{data?.EndDateformat} </div>,
        },
        {
            name: activeTab === 'Upcoming' || activeTab === 'Failed' || activeTab === 'Cancelled' ? 'Booking Status' : 'Cancellation Status',
            value: 'StatusName',
            sortable: true,
            reorder: true,
            selector: (data) => data?.StatusName,
            format: (data) =>
                <div className="d-flex bookingStatus " style={{ height: '60px' }} >
                    <button
                        type='button'
                        className={`btn border status ${activeTab} ${getBookingStatus(data?.BookingCondition)} ${activeTab === 'Failed' && data?.StatusName === 'Failed' ? 'faild_tab_button_p' : ''}`}
                        style={{ opacity: 1 }}
                        title={data?.StatusName}
                        onClick={(e) => {
                            setBookingId(data?.BookingId);
                            setModalShow(true);
                        }}
                        disabled={data.Product?.toString()?.toLowerCase() !== "Holiday"?.toLowerCase() || data?.BookingCondition === 0 || (!userRights?.URightAdd && !userRights?.URightEdit)}
                    >
                        {data?.StatusName}
                    </button>
                </div>
            ,
            omit: activeTab === 'Ongoing' || activeTab === "Completed" || activeTab === 'AutoCancelled',
        },
        {
            name: 'Booking Details',
            value: '',
            sortable: true,
            reorder: true,
            minWidth: '180px',
            selector: (data) => data?.Product !== "Holiday" ? <button type="button" className='btn p-0' onClick={() => openBookingDetails(data)} > <i className="fa-solid fa-download"></i> </button> : '',
            omit: !(activeTab === 'Upcoming' || activeTab === 'Completed')
        },
    ]

    useEffect(() => {
        setSearchDropdownList(columns?.filter((obj) => !obj?.omit))
    }, [activeTab])


    const [showFlightDetailModal, setShowFlightDetailModal] = useState(false);
    const [showHotelDetailModal, setShowHotelDetailModal] = useState(false);
    const [flightData, setFlightData] = useState([]);
    const [hotelData, setHotelData] = useState([]);

    const fetchIp = async () => {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            return {
                status: true,
                data: data?.ip
            }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return {
                status: false,
                data: null
            }
        }
    };

    const openBookingDetails = async (data) => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let userip = await fetchIp();
            if (userip?.status) {

                if (data?.Product === "Flight") {
                    const coll = {
                        EndUserIp: userip?.data,
                        PNR: data?.PNR,
                        BookingId: data?.TBOBookingId
                    }

                    await getAllData(`/master/v1/getCMSbookingcodebybookingid?bookingId=${data?.BookingId}`).then(async (res1) => {
                        if (res1?.status) {
                            await postUsersData('/master/v1/getCMSflightbookingdetails', coll).then((res2) => {
                                if (res2?.status) {
                                    setFlightData({ ...res1?.data?.[0], ...res2?.data })
                                    setShowFlightDetailModal(true);
                                }
                            })
                        }
                    })
                }
                else if (data?.Product === "Hotel") {
                    const coll = {
                        EndUserIp: userip?.data,
                        BookingId: data?.TBOBookingId
                    }

                    await postUsersData('/master/v1/getCMShotelbookingdetails', coll).then((res) => {
                        if (res?.status) {
                            setHotelData({ ...res?.data, data })
                            setShowHotelDetailModal(true);
                        }
                    })
                }

                dispatch(loaderActions.end());
            }
            else {
                dispatch(loaderActions.end());
                dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!' });
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }


    }



    const getBookingStatus = (status) => {
        switch (status) {
            case 0: return 'green-background'
            case 1: return 'yellow-background'
            default: return ''
        }
    }

    const handleApprove = async (bookingid) => {
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userdata = GetLocalStorage()
            dispatch(loaderActions.start());
            let data = {
                BookingStatus: activeTab === 'Upcoming' ? 2 : 5,
                BookingId: bookingid,
                UserId: userdata?.userMasterID
            }
            const updatebookingstatus = await postUsersData('/master/v1/updatebookingstatus', data)
            if (updatebookingstatus?.status) {
                dispatch(updatebooking());
                setModalShow(false);
            }
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }

    }
    const handleConfirmation = (e) => {
        if (e === true) {
            handleApprove(bookingId)
        }
        else {
            setModalShow(false);
        }
    }

    return (
        <div>

            <ConfirmationModal
                show={modalShow}
                modltitle="Confirmation"
                message={message}
                onHide={(e) => setModalShow(false)}
                yesconfirm={(e) => handleConfirmation(true)}
                noconfirm={(e) => handleConfirmation(false)}
            />

            <CustomTable
                className={`bookings ${activeTab}`}
                columns={columns}
                data={listData}
            />

            {/* Flight Details popup  */}
            {flightData && showFlightDetailModal &&
                <FlightBookingDetailPopup flightData={flightData} show={showFlightDetailModal} setShow={setShowFlightDetailModal} activeTab={activeTab} />}

            {/* Hotel Details popup  */}
            {hotelData && showHotelDetailModal &&
                <HotelBookingDetailPopup hotelData={hotelData} show={showHotelDetailModal} setShow={setShowHotelDetailModal} activeTab={activeTab} />}

        </div>
    )
}

export default BookingTable
